import { render } from "./index.vue?vue&type=template&id=6153b92e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=6153b92e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6153b92e"

export default script